import { Trans } from 'gatsby-plugin-react-i18next';
import React from 'react';

export const PRICING_PLAN = {
	SILVER: 1,
	GOLD: 2,
	PLATINUM: 3,
	ENTERPRISE: 4,
	1: 'silver',
	2: 'gold',
	3: 'platinum',
	4: 'enterprise',
	'silver': 1,
	'gold': 2,
	'platinum': 3,
	'enterprise': 4,
	LENGTH: 4
};

export const PRICING_PLAN_OPTION_CATEGORY = {
	PROGRAMME: 1,
	PERSONALISATION: 2,
	SUPPLIERS: 3,
	SUPPORT: 4,
	OPTIONS: 5,
	OTHER_OPTIONS: 6,
	1: <Trans i18nKey="pagePricing.plan.program" />,
	2: <Trans i18nKey="pagePricing.plan.personalization" />,
	3: <Trans i18nKey="pagePricing.plan.suppliers" />,
	4: <Trans i18nKey="pagePricing.plan.helpdesk" />,
	5: <Trans i18nKey="pagePricing.plan.options" />,
	6: <Trans i18nKey="pagePricing.plan.othersOptions" />,
};

export const PRICING_PLAN_OPTION_TYPE = {
	STANDARD: 1,
	PAY_EXTRA: 2,
};

export const PRICING_METHOD_OF_CALCULATION = {
	YEARLY: 1,
	MONTHLY: 2,
	FOR_EVERY_ORDER: 3,
	OTHER: 4, // get from customMethod
};

export const PRICING_OPTION_TYPE = {
	STANDARD: 1,
	PAY_EXTRA: 2,
	CONSTANT_VALUE: 3,
	LANGUAGE_DEPENDENT_VALUE: 4,
};

export const PRICING_DURATION_UNIT = {
	MONTHS: 1,
	YEARS: 2,
};
